<template>
  <div class="view-container">
    <div class="main-layout">
      <div class="left-panel">
        <div class="panel-header"><h4>流程目录</h4></div>
        <div class="panel-body">
          <table class="tree-table">
            <thead><tr><th>目录名称</th></tr></thead>
            <tbody>
              <template v-for="node in processFolderTree" :key="node.id">
                <tr class="tree-row" :class="{ selected: selectedFolderId === node.id }" @click="selectFolder(node)">
                  <td>
                    <span class="tree-name-cell">
                      <span v-if="node.children && node.children.length > 0" class="expand-icon" :class="{ expanded: expandedFolderIds.includes(node.id) }" @click.stop="toggleExpandFolder(node.id)"><i class="fas fa-caret-right"></i></span>
                      <span v-else class="expand-placeholder"></span>
                      <i class="fas" :class="node.children && node.children.length > 0 ? 'fa-folder' : 'fa-folder-open'"></i>
                      <span class="tree-name">{{ node.name }}</span>
                      <span class="count-badge" v-if="node.permissionCount !== undefined">{{ node.permissionCount }}</span>
                    </span>
                  </td>
                </tr>
                <template v-if="node.children && node.children.length > 0 && expandedFolderIds.includes(node.id)">
                  <tr v-for="child in node.children" :key="child.id" class="tree-row sub-row" :class="{ selected: selectedFolderId === child.id }" @click="selectFolder(child)" :style="{ paddingLeft: '20px' }">
                    <td>
                      <span class="tree-name-cell" style="padding-left: 16px">
                        <i class="fas" :class="child.isProcess ? 'fa-sitemap' : 'fa-folder-open'" :style="{ color: child.isProcess ? '#6366f1' : '' }"></i><span class="tree-name">{{ child.name }}</span>
                      </span>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <div class="right-panel">
        <div class="panel-body">
          <div v-if="selectedFolderId">
            <div class="search-panel">
              <div class="search-row">
                <div class="search-item">
                  <label><i class="fas fa-sitemap"></i> 流程名称</label>
                  <input v-model="searchForm.processName" type="text" placeholder="搜索流程" class="search-input">
                </div>
                <div class="search-item">
                  <label><i class="fas fa-tag"></i> 授权类型</label>
                  <select v-model="searchForm.targetType" class="search-select">
                    <option value="">全部</option>
                    <option value="user">用户</option>
                    <option value="org">组织</option>
                    <option value="role">角色</option>
                  </select>
                </div>
                <div class="search-actions">
                  <button @click="handleSearch" class="btn btn-primary search-btn"><i class="fas fa-search"></i> 查询</button>
                  <button @click="resetSearch" class="btn btn-default search-btn"><i class="fas fa-undo"></i> 重置</button>
                  <button @click="openAddDialog" class="btn btn-success search-btn"><i class="fas fa-plus"></i> 新增权限</button>
                  <button @click="batchSelectAll" class="btn btn-default search-btn"><i class="fas fa-check-square"></i> 全选</button>
                  <button @click="batchEdit" class="btn btn-warning search-btn" :disabled="selectedIds.length === 0"><i class="fas fa-edit"></i> 批量修改 ({{ selectedIds.length }})</button>
                </div>
              </div>
            </div>

            <div class="table-container-inner">
              <table class="data-table">
                <thead><tr>
                  <th width="40"><input type="checkbox" :checked="isAllSelected" @change="toggleAllSelect"></th>
                  <th width="50">ID</th><th>流程名称</th><th width="80">授权类型</th><th>授权对象</th>
                  <th width="60">发起</th><th width="60">查看</th><th width="60">管理</th><th width="60">修改</th><th width="60">批量</th>
                  <th width="70">状态</th><th width="120">操作</th>
                </tr></thead>
                <tbody>
                  <tr v-for="p in paginatedData" :key="p.id">
                    <td><input type="checkbox" :checked="selectedIds.includes(p.id)" @change="toggleSelect(p.id)"></td>
                    <td>{{ p.id }}</td><td>{{ p.processName }}</td>
                    <td><span class="type-badge" :class="p.targetType">{{ typeLabels[p.targetType] }}</span></td>
                    <td>{{ p.targetName }}</td>
                    <td v-for="col in ['canLaunch','canView','canManage','canModify','canBatch']" :key="col">
                      <label class="switch-label"><input type="checkbox" v-model="p[col]" @change="updatePermission(p)"><span class="switch-on">是</span><span class="switch-off">否</span></label>
                    </td>
                    <td><span class="status-badge" :class="p.status==='启用'?'enabled':'disabled'">{{ p.status }}</span></td>
                    <td class="action-cell">
                      <button @click="editPermission(p)" class="btn btn-primary btn-xs" title="编辑"><i class="fas fa-edit"></i></button>
                      <button @click="toggleStatus(p)" class="btn btn-xs" :class="p.status==='启用'?'btn-warning':'btn-success'"><i class="fas" :class="p.status==='启用'?'fa-ban':'fa-check'"></i></button>
                      <button @click="deletePermission(p)" class="btn btn-danger btn-xs"><i class="fas fa-trash"></i></button>
                    </td>
                  </tr>
                  <tr v-if="paginatedData.length === 0"><td colspan="12" class="empty-cell">该目录暂无权限数据</td></tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-row">
              <div class="pagination-info">共 {{ totalCount }} 条记录</div>
              <div class="pagination-controls">
                <div class="page-size-selector"><span>每页</span><select v-model="pageSize" class="page-size-input form-control"><option :value="10">10</option><option :value="20">20</option><option :value="50">50</option></select><span>条</span></div>
                <button @click="prevPage" :disabled="currentPage===1" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-left"></i></button>
                <div class="page-numbers"><button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="['page-btn',{active:currentPage===page,disabled:page==='...'}]" :disabled="page==='...'">{{ page }}</button></div>
                <button @click="nextPage" :disabled="currentPage>=totalPages" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-right"></i></button>
              </div>
            </div>
          </div>
          <div v-else class="empty-state"><i class="fas fa-sitemap"></i><p>请选择一个流程目录</p><p class="hint">左侧目录树点击即可查看对应流程权限</p></div>
        </div>
      </div>
    </div>

    <div v-if="showFormModal" class="modal-overlay" @click.self="closeFormModal">
      <div class="modal-container">
        <div class="modal-header"><h3>{{ editingId ? '编辑权限' : '新增权限' }}</h3><button @click="closeFormModal" class="close-btn"><i class="fas fa-times"></i></button></div>
        <div class="modal-body">
          <div class="form-row"><div class="form-group"><label>流程 *</label><div class="search-select"><input v-model="form.processName" type="text" class="form-control" readonly @click="showProcessPicker=true"><button @click="showProcessPicker=true" class="search-btn"><i class="fas fa-search"></i></button></div></div></div>
          <div class="form-row">
            <div class="form-group"><label>授权类型 *</label><select v-model="form.targetType" class="form-control"><option value="user">用户</option><option value="org">组织</option><option value="role">角色</option></select></div>
            <div class="form-group"><label>授权对象 *</label><div class="search-select"><input v-model="form.targetName" class="form-control" readonly @click="openTargetPicker"><button @click="openTargetPicker" class="search-btn"><i class="fas fa-search"></i></button></div></div>
          </div>
          <div class="form-group" style="margin-bottom: 15px"><label>权限设置</label></div>
          <div class="permission-checks">
            <label class="perm-check"><input type="checkbox" v-model="form.canLaunch"> 可发起（发起该流程）</label>
            <label class="perm-check"><input type="checkbox" v-model="form.canView"> 可查看（查看流程详情、流程图等）</label>
            <label class="perm-check"><input type="checkbox" v-model="form.canManage"> 可管理（编辑、删除、调度、返回等）</label>
            <label class="perm-check"><input type="checkbox" v-model="form.canModify"> 可修改</label>
            <label class="perm-check"><input type="checkbox" v-model="form.canBatch"> 可批量操作（批量审批、批量处理）</label>
          </div>
          <div class="form-row" style="margin-top: 15px">
            <div class="form-group"><label>状态</label><select v-model="form.status" class="form-control"><option value="启用">启用</option><option value="禁用">禁用</option></select></div>
            <div class="form-group"><label>备注</label><input v-model="form.remark" class="form-control" placeholder="备注"></div>
          </div>
        </div>
        <div class="modal-footer"><button @click="closeFormModal" class="btn btn-default">取消</button><button @click="saveForm" class="btn btn-primary">保存</button></div>
      </div>
    </div>

    <div v-if="showProcessPicker" class="modal-overlay" @click.self="showProcessPicker=false">
      <div class="modal-container picker-modal">
        <div class="modal-header"><h3>选择流程</h3><button @click="showProcessPicker=false" class="close-btn"><i class="fas fa-times"></i></button></div>
        <div class="modal-body">
          <div class="search-box"><input v-model="processSearch" class="form-control" placeholder="搜索流程"></div>
          <div class="picker-list">
            <div v-for="f in filteredProcesses" :key="f.id" class="picker-item" @click="selectProcess(f)" :class="{ selected: form.processId === f.id }">
              <i class="fas fa-sitemap"></i><span>{{ f.name }}</span><span class="picker-info">{{ f.folderName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showTargetPicker" class="modal-overlay" @click.self="showTargetPicker=false">
      <div class="modal-container picker-modal">
        <div class="modal-header"><h3>选择{{ targetTypeLabel }}</h3><button @click="showTargetPicker=false" class="close-btn"><i class="fas fa-times"></i></button></div>
        <div class="modal-body">
          <div class="search-box">
            <div class="search-input-wrap">
              <i class="fas fa-search search-icon"></i>
              <input v-model="targetSearch" class="search-box-input" :placeholder="'搜索' + targetTypeLabel">
            </div>
          </div>
          <div class="picker-list">
            <template v-if="form.targetType === 'user'">
              <div v-for="item in filteredTargets" :key="item.id" class="picker-item" @click="selectTarget(item)" :class="{ selected: form.targetId === item.id }">
                <i class="fas fa-user"></i>
                <span>{{ item.name }}</span>
              </div>
            </template>
            <template v-else>
              <div v-for="item in filteredTargets" :key="item.id" class="picker-item tree-item" :class="['tree-level-' + (item.level || 0), { selected: form.targetId === item.id }]" @click="selectTarget(item)">
                <i class="fas" :class="form.targetType==='org'?'fa-building':'fa-user-tag'"></i>
                <span>{{ item.name }}</span>
                <span v-if="item.hasChildren" class="tree-hint">···</span>
              </div>
            </template>
            <div v-if="filteredTargets.length === 0" class="picker-empty">无匹配结果</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showBatchModal" class="modal-overlay" @click.self="showBatchModal=false">
      <div class="modal-container" style="width:500px">
        <div class="modal-header"><h3>批量修改权限 - {{ selectedIds.length }} 条记录</h3><button @click="showBatchModal=false" class="close-btn"><i class="fas fa-times"></i></button></div>
        <div class="modal-body">
          <div class="form-group" style="margin-bottom:15px"><label>批量设置</label></div>
          <div class="permission-checks">
            <label class="perm-check"><input type="checkbox" v-model="batchForm.canLaunch"> 可发起</label>
            <label class="perm-check"><input type="checkbox" v-model="batchForm.canView"> 可查看</label>
            <label class="perm-check"><input type="checkbox" v-model="batchForm.canManage"> 可管理</label>
            <label class="perm-check"><input type="checkbox" v-model="batchForm.canModify"> 可修改</label>
            <label class="perm-check"><input type="checkbox" v-model="batchForm.canBatch"> 可批量操作</label>
          </div>
          <div class="form-row" style="margin-top:15px"><div class="form-group"><label>状态</label><select v-model="batchForm.status" class="form-control"><option value="">不修改</option><option value="启用">启用</option><option value="禁用">禁用</option></select></div></div>
        </div>
        <div class="modal-footer"><button @click="showBatchModal=false" class="btn btn-default">取消</button><button @click="applyBatch" class="btn btn-primary">应用 ({{ selectedIds.length }})</button></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { getCatalogs, getProcessList } from '../api/process'
import { getProcessPermissions, saveProcessPermission, deleteProcessPermission } from '../api/permission'
import { getUserList } from '../api/user'
import { getOrgTree } from '../api/org'
import { getRoleTree } from '../api/role'

const typeLabels = { user: '用户', org: '组织', role: '角色' }
const currentPage = ref(1); const pageSize = ref(10)
const selectedFolderId = ref(null); const expandedFolderIds = ref([])
const showFormModal = ref(false); const showProcessPicker = ref(false); const showTargetPicker = ref(false); const showBatchModal = ref(false)
const editingId = ref(null); const processSearch = ref(''); const targetSearch = ref('')
const selectedIds = ref([])
const processChildMap = ref({})

const searchForm = reactive({ processName: '', targetType: '' })
const form = reactive({ id: null, guid: null, processId: null, processName: '', folderId: null, targetType: 'user', targetId: null, targetName: '', canLaunch: true, canView: false, canManage: false, canModify: false, canBatch: false, status: '启用', remark: '' })
const batchForm = reactive({ canLaunch: false, canView: false, canManage: false, canModify: false, canBatch: false, status: '' })

const processFolderTree = ref([])
const permissions = ref([])
const processes = ref([])
const users = ref([])
const orgs = ref([])
const rls = ref([])
const orgTree = ref([])   // 树形数据
const roleTree = ref([])  // 树形数据

/* ---------- AlloyPermission bit 映射 ---------- */
/** Bit0=发起, Bit1=查看, Bit2=管理, Bit3=修改, Bit4=批量 */
const alloyToPerms = (alloy) => {
  if (!alloy) return { canLaunch: false, canView: false, canManage: false, canModify: false, canBatch: false }
  return {
    canLaunch: alloy.length >= 1 && alloy[0] === '1',
    canView: alloy.length >= 2 && alloy[1] === '1',
    canManage: alloy.length >= 3 && alloy[2] === '1',
    canModify: alloy.length >= 4 && alloy[3] === '1',
    canBatch: alloy.length >= 5 && alloy[4] === '1'
  }
}
const permsToAlloy = (p) => (p.canLaunch ? '1' : '0') + (p.canView ? '1' : '0') + (p.canManage ? '1' : '0') + (p.canModify ? '1' : '0') + (p.canBatch ? '1' : '0')

/* ---------- 数据加载 ---------- */
/** 加载流程目录树 */
async function loadCatalogs() {
  processChildMap.value = {}
  try {
    const res = await getCatalogs()
    const list = Array.isArray(res) ? res : (res?.data || [])
    processFolderTree.value = list.map(c => ({
      id: c.id,
      guid: c.id,
      name: c.text || c.enName || '',
      children: (c.childFolder || []).map(ch => ({ id: ch.id, guid: ch.id, name: ch.text || ch.enName || '' }))
    }))
  } catch (e) { console.error('[LaPermissions] loadCatalogs error:', e); processFolderTree.value = [] }
}

/** 加载指定目录下的流程及其权限 */
async function loadProcessesAndPermissions(folderId) {
  try {
    const procRes = await getProcessList(folderId)
    const procList = (Array.isArray(procRes) ? procRes : (procRes?.data || [])).map(p => ({
      id: p.guid || p.id,
      guid: p.guid || p.id,
      name: p.processName || p.name || '',
      folderId: folderId,
      folderName: ''
    }))
    processes.value = procList

    // 加载每个流程的权限
    const allPerms = []
    let idSeq = 1
    for (const proc of procList) {
      try {
        const permRes = await getProcessPermissions(proc.guid || proc.id)
        const permList = Array.isArray(permRes) ? permRes : (permRes?.data || [])
        for (const item of permList) {
          const perms = alloyToPerms(item.alloyPermission)
          // 查找授权对象显示名称
          let targetName = item.operatorPara1 || item.operatorID || ''
          const opType = item.operatorType || ''
          const opID = item.operatorID || ''
          if (opType === 'User') {
            const u = users.value.find(u => u.id === opID)
            if (u) targetName = u.name
          } else if (opType === 'Org') {
            const o = orgs.value.find(o => o.id === opID)
            if (o) targetName = o.name
          } else if (opType === 'Role') {
            const r = rls.value.find(r => r.id === opID)
            if (r) targetName = r.name
          }
          allPerms.push({
            id: idSeq++,
            guid: item.guid,
            processId: proc.guid || proc.id,
            processName: proc.name,
            folderId: folderId,
            targetType: (opType || '').toLowerCase(),
            targetId: opID,
            targetName: targetName,
            ...perms,
            status: item.active === 1 ? '启用' : '禁用',
            remark: item.operatorPara1 || ''
          })
        }
      } catch (e) { console.error('[LaPermissions] loadPerm error:', proc.id, e) }
    }
    permissions.value = allPerms
  } catch {
    processes.value = []
    permissions.value = []
  }
}

/** 加载用户列表 */
async function loadUsers() {
  try {
    const res = await getUserList()
    const list = Array.isArray(res) ? res : (res?.data || [])
    users.value = list.map(u => ({ id: u.guid, guid: u.guid, name: u.displayName || u.account || '' }))
  } catch { users.value = [] }
}

/** 加载组织列表（扁平化树） */
async function loadOrgs() {
  try {
    const res = await getOrgTree()
    const list = Array.isArray(res) ? res : (res?.data || [])
    orgTree.value = list
    const flat = (nodes) => {
      let r = []
      for (const n of (nodes || [])) {
        const name = n.ousName || n.oUsName || n.OUsName || ''
        const children = n.children || n.childFolder
        r.push({ id: n.guid, guid: n.guid, name })
        if (children) r = r.concat(flat(children))
      }
      return r
    }
    orgs.value = flat(list)
  } catch { orgTree.value = []; orgs.value = [] }
}

/** 加载角色列表（扁平化树） */
async function loadRoles() {
  try {
    const res = await getRoleTree()
    const list = Array.isArray(res) ? res : (res?.data || [])
    roleTree.value = list
    const flat = (nodes) => {
      let r = []
      for (const n of (nodes || [])) {
        const children = n.children || n.childFolder
        r.push({ id: n.guid, guid: n.guid, name: n.roleName || '' })
        if (children) r = r.concat(flat(children))
      }
      return r
    }
    rls.value = flat(list)
  } catch { roleTree.value = []; rls.value = [] }
}

onMounted(() => { loadCatalogs(); loadUsers(); loadOrgs(); loadRoles() })

/* ---------- 计算属性 ---------- */
const filteredData = computed(() => {
  let r = permissions.value
  if (searchForm.processName) r = r.filter(p => p.processName.includes(searchForm.processName))
  if (searchForm.targetType) r = r.filter(p => p.targetType === searchForm.targetType)
  return r
})
const totalCount = computed(() => filteredData.value.length)
const totalPages = computed(() => Math.ceil(totalCount.value / pageSize.value) || 1)
const paginatedData = computed(() => { const s = (currentPage.value - 1) * pageSize.value; return filteredData.value.slice(s, s + pageSize.value) })
const visiblePages = computed(() => { const ps = [], t = totalPages.value, c = currentPage.value; if (t <= 7) { for (let i = 1; i <= t; i++) ps.push(i) } else { ps.push(1); if (c > 4) ps.push('...'); for (let i = Math.max(2, c - 2); i <= Math.min(t - 1, c + 2); i++) ps.push(i); if (c < t - 3) ps.push('...'); ps.push(t) } return ps })
const filteredProcesses = computed(() => !processSearch.value ? processes.value : processes.value.filter(p => p.name.includes(processSearch.value)))
const targetTypeLabel = computed(() => ({ user: '用户', org: '组织', role: '角色' })[form.targetType] || '')
function flattenForPicker(nodes, level = 0) {
  let result = []
  for (const n of (nodes || [])) {
    const name = form.targetType === 'org'
      ? (n.ousName || n.oUsName || n.OUsName || '')
      : (n.roleName || '')
    const children = n.children || n.childFolder || []
    result.push({ id: n.guid, name, level, hasChildren: children.length > 0 })
    if (children.length > 0) {
      result = result.concat(flattenForPicker(children, level + 1))
    }
  }
  return result
}
const filteredTargets = computed(() => {
  if (form.targetType === 'user') {
    return !targetSearch.value ? users.value : users.value.filter(i => (i.name || '').includes(targetSearch.value))
  }
  const tree = form.targetType === 'org' ? orgTree.value : roleTree.value
  let flat = flattenForPicker(tree)
  if (targetSearch.value) flat = flat.filter(i => (i.name || '').includes(targetSearch.value))
  return flat
})
const isAllSelected = computed(() => { const ids = paginatedData.value.map(p => p.id); return ids.length > 0 && ids.every(id => selectedIds.value.includes(id)) })

/* ---------- 目录树操作 ---------- */
const toggleExpandFolder = (id) => {
  const idx = expandedFolderIds.value.indexOf(id)
  if (idx !== -1) {
    expandedFolderIds.value.splice(idx, 1)
  } else {
    expandedFolderIds.value.push(id)
    const folderNode = findNodeById(processFolderTree.value, id)
    if (folderNode) loadProcessTreeChildren(folderNode)
  }
}
const selectFolder = (node) => {
  selectedFolderId.value = node.id
  currentPage.value = 1
  selectedIds.value = []

  if (node.isProcess) {
    // Process node clicked - load only this process's permissions
    loadSingleProcessPermissions(node.guid, node.name)
  } else {
    // Folder node clicked - expand and load processes as children
    if (!expandedFolderIds.value.includes(node.id)) {
      expandedFolderIds.value.push(node.id)
    }
    loadProcessTreeChildren(node)
    loadProcessesAndPermissions(node.id)
  }
}

/** 递归查找树节点 */
const findNodeById = (tree, id) => {
  for (const node of tree) {
    if (node.id === id) return node
    if (node.children) {
      const found = findNodeById(node.children, id)
      if (found) return found
    }
  }
  return null
}

/** 为目录节点加载子流程列表，添加到树中 */
const loadProcessTreeChildren = async (folderNode) => {
  if (processChildMap.value[folderNode.id]) return
  try {
    const procRes = await getProcessList(folderNode.id)
    const procList = (Array.isArray(procRes) ? procRes : (procRes?.data || [])).map(p => ({
      id: 'proc_' + (p.guid || p.id),
      guid: p.guid || p.id,
      name: p.processName || p.name || '',
      isProcess: true,
      parentFolderId: folderNode.id
    }))
    processChildMap.value[folderNode.id] = procList
    // 保留原有的子目录节点，追加流程节点
    if (!folderNode.children) folderNode.children = []
    folderNode.children = [...folderNode.children.filter(c => !c.isProcess), ...procList]
  } catch (e) {
    console.error('[LaPermissions] loadProcessTreeChildren error:', e)
    processChildMap.value[folderNode.id] = []
  }
}

/** 加载单个流程的权限 */
const loadSingleProcessPermissions = async (processGuid, processName) => {
  try {
    const permRes = await getProcessPermissions(processGuid)
    const permList = Array.isArray(permRes) ? permRes : (permRes?.data || [])
    const allPerms = []
    let idSeq = 1
    for (const item of permList) {
      const perms = alloyToPerms(item.alloyPermission)
      let targetName = item.operatorPara1 || item.operatorID || ''
      const opType = item.operatorType || ''
      const opID = item.operatorID || ''
      if (opType === 'User') {
        const u = users.value.find(u => u.id === opID)
        if (u) targetName = u.name
      } else if (opType === 'Org') {
        const o = orgs.value.find(o => o.id === opID)
        if (o) targetName = o.name
      } else if (opType === 'Role') {
        const r = rls.value.find(r => r.id === opID)
        if (r) targetName = r.name
      }
      allPerms.push({
        id: idSeq++,
        guid: item.guid,
        processId: processGuid,
        processName: processName,
        targetType: (opType || '').toLowerCase(),
        targetId: opID,
        targetName: targetName,
        ...perms,
        status: item.active === 1 ? '启用' : '禁用',
        remark: item.operatorPara1 || ''
      })
    }
    permissions.value = allPerms
    processes.value = [{ id: processGuid, guid: processGuid, name: processName }]
  } catch (e) {
    console.error('[LaPermissions] loadSingleProcessPermissions error:', e)
    permissions.value = []
    processes.value = []
  }
}

/* ---------- 搜索/分页 ---------- */
const handleSearch = () => { currentPage.value = 1 }
const resetSearch = () => { Object.keys(searchForm).forEach(k => searchForm[k] = ''); currentPage.value = 1 }
const prevPage = () => { if (currentPage.value > 1) currentPage.value-- }
const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++ }
const goToPage = (p) => { if (typeof p === 'number' && p >= 1 && p <= totalPages.value) currentPage.value = p }

/* ---------- 选择/批量 ---------- */
const toggleSelect = (id) => { const idx = selectedIds.value.indexOf(id); if (idx !== -1) selectedIds.value.splice(idx, 1); else selectedIds.value.push(id) }
const toggleAllSelect = () => { if (isAllSelected.value) selectedIds.value = []; else selectedIds.value = paginatedData.value.map(p => p.id) }
const batchSelectAll = () => { selectedIds.value = filteredData.value.map(p => p.id) }
const batchEdit = () => { if (selectedIds.value.length === 0) { $message.warning('请先选择记录'); return }; Object.assign(batchForm, { canView: false, canLaunch: false, canManage: false, canBatch: false, status: '' }); showBatchModal.value = true }
const applyBatch = async () => {
  const updates = selectedIds.value.map(id => permissions.value.find(x => x.id === id)).filter(Boolean)
  for (const p of updates) {
    if (batchForm.status) p.status = batchForm.status
    ;['canLaunch','canView','canManage','canModify','canBatch'].forEach(k => { if (batchForm[k]) p[k] = batchForm[k] })
    try {
      await saveProcessPermission({
        Guid: p.guid,
        OperatorType: p.targetType === 'user' ? 'User' : p.targetType === 'org' ? 'Org' : 'Role',
        OperatorID: p.targetId,
        OperatorPara1: p.targetName,
        ResourceType: 'Process',
        ResourceID: p.processId,
        AlloyPermission: permsToAlloy(p),
        Active: p.status === '启用' ? 1 : 0
      })
    } catch { /* skip */ }
  }
  showBatchModal.value = false
  selectedIds.value = []
  if (selectedFolderId.value) loadProcessesAndPermissions(selectedFolderId.value)
}

/* ---------- 表单操作 ---------- */
const openAddDialog = () => {
  editingId.value = null
  let folderId = selectedFolderId.value
  const selectedNode = findNodeById(processFolderTree.value, selectedFolderId.value)
  if (selectedNode && selectedNode.isProcess && selectedNode.parentFolderId) {
    folderId = selectedNode.parentFolderId
  }
  Object.assign(form, { id: null, guid: null, processId: null, processName: '', folderId: folderId, targetType: 'user', targetId: null, targetName: '', canLaunch: true, canView: false, canManage: false, canModify: false, canBatch: false, status: '启用', remark: '' })
  showFormModal.value = true
}
const editPermission = (p) => { editingId.value = p.id; Object.assign(form, { ...p }); showFormModal.value = true }
const closeFormModal = () => { showFormModal.value = false; editingId.value = null }

const saveForm = async () => {
  if (!form.processId || !form.targetId) { $message.warning('请选择流程和授权对象'); return }
  const payload = {
    Guid: form.guid || undefined,
    OperatorType: form.targetType === 'user' ? 'User' : form.targetType === 'org' ? 'Org' : 'Role',
    OperatorID: form.targetId,
    OperatorPara1: form.targetName,
    ResourceType: 'Process',
    ResourceID: form.processId,
    AlloyPermission: permsToAlloy(form),
    Active: form.status === '启用' ? 1 : 0
  }
  try {
    await saveProcessPermission(payload)
    closeFormModal()
    if (selectedFolderId.value) loadProcessesAndPermissions(selectedFolderId.value)
  } catch (e) { console.error('保存权限失败', e); $message.error('保存失败，请重试') }
}

const toggleStatus = async (p) => {
  const newStatus = p.status === '启用' ? '禁用' : '启用'
  try {
    await saveProcessPermission({
      Guid: p.guid,
      OperatorType: p.targetType === 'user' ? 'User' : p.targetType === 'org' ? 'Org' : 'Role',
      OperatorID: p.targetId,
      OperatorPara1: p.targetName,
      ResourceType: 'Process',
      ResourceID: p.processId,
      AlloyPermission: permsToAlloy(p),
      Active: newStatus === '启用' ? 1 : 0
    })
    p.status = newStatus
    $message.success('已' + newStatus)
  } catch (e) {
    console.error('切换状态失败', e)
    $message.error(newStatus + '失败，请重试')
  }
}

const deletePermission = async (p) => {
  if (!await $confirm('确定删除该权限记录吗？')) return
  try {
    await deleteProcessPermission(p.guid)
    permissions.value = permissions.value.filter(x => x.id !== p.id)
    selectedIds.value = selectedIds.value.filter(id => id !== p.id)
  } catch (e) { console.error('删除权限失败', e); $message.error('删除失败，请重试') }
}

/** 单个开关切换时调用 */
const updatePermission = async (p) => {
  try {
    await saveProcessPermission({
      Guid: p.guid,
      OperatorType: p.targetType === 'user' ? 'User' : p.targetType === 'org' ? 'Org' : 'Role',
      OperatorID: p.targetId,
      OperatorPara1: p.targetName,
      ResourceType: 'Process',
      ResourceID: p.processId,
      AlloyPermission: permsToAlloy(p),
      Active: p.status === '启用' ? 1 : 0
    })
  } catch { /* skip */ }
}

/* ---------- 选择器 ---------- */
const selectProcess = (f) => { form.processId = f.id; form.processName = f.name; form.folderId = f.folderId; showProcessPicker.value = false }
const selectTarget = (item) => { form.targetId = item.id; form.targetName = item.name; showTargetPicker.value = false }
const openTargetPicker = () => { targetSearch.value = ''; showTargetPicker.value = true }
</script>

<style scoped>
.view-container { padding: 16px; background: #f5f7fa; }
.main-layout { display: flex; gap: 16px; min-height: calc(94vh - 110px); max-height: calc(94vh - 110px); }
.left-panel { flex: 0 0 22%; background: #fff; border-radius: 6px; border: 1px solid #e8ecf1; overflow: hidden; display: flex; flex-direction: column; }
.panel-header { padding: 10px 12px; border-bottom: 1px solid #e8ecf1; background: #fafbfc; }
.panel-header h4 { margin: 0; font-size: 13px; font-weight: 600; color: #374151; }
.panel-body { height: 100%; padding: 8px; overflow-y: auto; }
.right-panel { flex: 1; background: #fff; border-radius: 6px; border: 1px solid #e8ecf1; overflow: hidden; }
.tree-table { width: 100%; border-collapse: collapse; }
.tree-table thead th { padding: 8px 10px; font-size: 11px; font-weight: 600; color: #6b7280; background: #f8fafc; border-bottom: 1px solid #e8ecf1; text-align: left; }
.tree-table tbody td { padding: 7px 10px; border-bottom: 1px solid #f3f4f6; font-size: 12px; color: #374151; }
.tree-row { cursor: pointer; transition: background 0.1s; }
.tree-row:hover { background: #f9fafb; }
.tree-row.selected { background: #ecfdf5; }
.tree-row.selected td { color: #059669; }
.tree-name-cell { display: flex; align-items: center; gap: 4px; }
.expand-icon { width: 14px; height: 14px; display: flex; align-items: center; justify-content: center; color: #9ca3af; font-size: 9px; cursor: pointer; }
.expand-icon:hover { color: #10b981; }
.expand-icon.expanded i { transform: rotate(90deg); }
.expand-placeholder { width: 14px; }
.tree-name-cell i { color: #10b981; font-size: 11px; }
.tree-name { margin-left: 2px; font-size: 12px; }
.count-badge { margin-left: 4px; background: #ecfdf5; color: #059669; font-size: 10px; padding: 0 5px; border-radius: 8px; min-width: 16px; text-align: center; display: inline-block; line-height: 16px; }

.search-panel { padding: 10px 14px; background: #fafbfc; border-bottom: 1px solid #e8ecf1; }
.search-row { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
.search-item { display: flex; align-items: center; gap: 6px; }
.search-item label { font-size: 13px; color: #374151; font-weight: 500; white-space: nowrap; }
.search-item label i { color: #10b981; margin-right: 2px; font-size: 12px; }
.search-input, .search-select { padding: 7px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; width: 160px; outline: none; transition: border-color 0.2s; }
.search-input:focus, .search-select:focus { border-color: #10b981; }
.search-actions { display: flex; gap: 6px; margin-left: auto; align-items: center; }
.search-btn { padding: 6px 12px; font-size: 12px; border-radius: 6px; display: flex; align-items: center; gap: 4px; }

.table-container-inner { flex: 1; overflow-y: auto; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 8px 10px; border-bottom: 1px solid #e7eaec; font-size: 12px; color: #676a6c; text-align: left; white-space: nowrap; }
.data-table th { background: #f5f5f5; font-weight: 600; position: sticky; top: 0; z-index: 2; }
.data-table tbody tr:hover { background: #f9fafb; }
.empty-cell { text-align: center; padding: 40px; color: #999; }
.action-cell { white-space: nowrap; text-align: center; }
.action-cell .btn-xs { margin: 0 2px; padding: 4px 8px; font-size: 11px; border-radius: 4px; cursor: pointer; border: 1px solid transparent; }
.btn-primary.btn-xs { background: #3498db; color: #fff; }
.btn-warning.btn-xs { background: #f39c12; color: #fff; }
.btn-danger.btn-xs { background: #e74c3c; color: #fff; }
.btn-success.btn-xs { background: #27ae60; color: #fff; }
.type-badge { display: inline-block; padding: 2px 6px; border-radius: 3px; font-size: 10px; font-weight: 500; background: #f0f4ff; color: #6366f1; }
.status-badge { display: inline-block; padding: 2px 6px; border-radius: 3px; font-size: 10px; font-weight: 500; }
.status-badge.enabled { background: #dcfce7; color: #16a34a; }
.status-badge.disabled { background: #fee2e2; color: #dc2626; }
.switch-label { display: inline-flex; align-items: center; cursor: pointer; }
.switch-label input { display: none; }
.switch-on, .switch-off { font-size: 11px; padding: 2px 6px; border-radius: 3px; }
.switch-label input:checked ~ .switch-on { background: #dcfce7; color: #16a34a; font-weight: 600; }
.switch-label input:checked ~ .switch-off { display: none; }
.switch-label input:not(:checked) ~ .switch-off { background: #fee2e2; color: #dc2626; }
.switch-label input:not(:checked) ~ .switch-on { display: none; }

.pagination-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; background: #f9f9f9; border-top: 1px solid #e7eaec; flex-shrink: 0; }
.pagination-info { font-size: 12px; color: #676a6c; }
.pagination-controls { display: flex; align-items: center; gap: 8px; }
.page-numbers { display: flex; gap: 4px; }
.page-btn { width: 28px; height: 28px; border: 1px solid #e7eaec; background: #fff; color: #676a6c; border-radius: 3px; cursor: pointer; font-size: 12px; display: flex; align-items: center; justify-content: center; }
.page-btn:hover:not(.disabled) { border-color: #10b981; color: #10b981; }
.page-btn.active { background: #10b981; border-color: #10b981; color: #fff; }
.page-btn.disabled { cursor: not-allowed; opacity: 0.5; }
.pagination-btn { width: 28px; height: 28px; padding: 0; display: flex; align-items: center; justify-content: center; }
.page-size-selector { display: flex; align-items: center; gap: 4px; font-size: 12px; }
.page-size-input { width: 60px; padding: 3px 6px; font-size: 12px; }

.empty-state { text-align: center; padding: 60px 20px; color: #9ca3af; }
.empty-state i { font-size: 48px; margin-bottom: 12px; color: #d1d5db; }
.empty-state p { font-size: 14px; margin-bottom: 4px; }
.empty-state .hint { font-size: 12px; color: #d1d5db; }

.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-container { background: #fff; border-radius: 8px; width: 600px; max-height: 80vh; overflow-y: auto; }
.picker-modal { width: 450px; }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; border-bottom: 1px solid #e7eaec; }
.modal-header h3 { margin: 0; font-size: 16px; }
.close-btn { background: none; border: none; font-size: 22px; cursor: pointer; color: #999; }
.close-btn:hover { color: #333; }
.modal-body { padding: 20px; }
.modal-footer { padding: 12px 20px; border-top: 1px solid #e7eaec; display: flex; justify-content: flex-end; gap: 10px; }
.form-row { display: flex; gap: 15px; margin-bottom: 15px; }
.form-group { flex: 1; }
.form-group label { display: block; font-size: 13px; color: #676a6c; margin-bottom: 5px; font-weight: 500; }
.form-group .form-control { width: 100%; padding: 8px 12px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; box-sizing: border-box; }
.search-select { display: flex; gap: 6px; }
.search-select .form-control { flex: 1; cursor: pointer; }
.search-btn { padding: 6px 10px; border: 1px solid #e7eaec; border-radius: 4px; background: #f9f9f9; cursor: pointer; color: #676a6c; }
.search-btn:hover { background: #e7eaec; }
.search-box { margin-bottom: 12px; }
.search-input-wrap { position: relative; display: flex; align-items: center; }
.search-icon { position: absolute; left: 10px; color: #9ca3af; font-size: 13px; z-index: 1; }
.search-box-input { width: 100%; padding: 8px 10px 8px 30px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; outline: none; box-sizing: border-box; transition: border-color 0.2s; }
.search-box-input:focus { border-color: #10b981; }
.picker-list { max-height: 320px; overflow-y: auto; }
.picker-item { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-bottom: 1px solid #f3f4f6; cursor: pointer; font-size: 13px; color: #374151; transition: background 0.15s; }
.picker-item:hover { background: #f9fafb; }
.picker-item.selected { background: #ecfdf5; color: #059669; font-weight: 500; }
.picker-item i { color: #10b981; font-size: 12px; width: 16px; text-align: center; flex-shrink: 0; }
.tree-level-0 { padding-left: 14px; }
.tree-level-1 { padding-left: 36px; }
.tree-level-2 { padding-left: 58px; }
.tree-level-3 { padding-left: 80px; }
.tree-hint { margin-left: auto; font-size: 10px; color: #d1d5db; }
.picker-empty { text-align: center; padding: 30px 0; color: #9ca3af; font-size: 13px; }
.permission-checks { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.perm-check { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #374151; cursor: pointer; }
.perm-check input[type="checkbox"] { width: 16px; height: 16px; cursor: pointer; }

.btn { padding: 6px 14px; border: 1px solid transparent; border-radius: 4px; font-size: 13px; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; transition: all 0.2s; }
.btn-primary { background: #10b981; color: #fff; border-color: #10b981; }
.btn-primary:hover { background: #059669; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }
.btn-success { background: #6366f1; color: #fff; border-color: #6366f1; }
.btn-success:hover { background: #4f46e5; }
.btn-warning { background: #f59e0b; color: #fff; border-color: #f59e0b; }
.btn-warning:hover { background: #d97706; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
</style>
